const $ = require('jquery')

const SCI = require('sci')
const Vue = require('vue')
const R = require('ramda')

const client = require('sci/helpers/client')
const vueChaos = require('sci/helpers/vue-chaos')

const template = require('templates/ui-addressing.html')

const cache = {}

const options = SCI.get('global-options') || {}

options.states = [
    { 'id': 1, 'name': 'Acre', 'abbreviation': 'AC' },
    { 'id': 2, 'name': 'Alagoas', 'abbreviation': 'AL' },
    { 'id': 3, 'name': 'Amapá', 'abbreviation': 'AP' },
    { 'id': 4, 'name': 'Amazonas', 'abbreviation': 'AM' },
    { 'id': 5, 'name': 'Bahia', 'abbreviation': 'BA' },
    { 'id': 6, 'name': 'Ceará', 'abbreviation': 'CE' },
    { 'id': 7, 'name': 'Distrito Federal', 'abbreviation': 'DF' },
    { 'id': 8, 'name': 'Espírito Santo', 'abbreviation': 'ES' },
    { 'id': 9, 'name': 'Goiás', 'abbreviation': 'GO' },
    { 'id': 10, 'name': 'Maranhão', 'abbreviation': 'MA' },
    { 'id': 11, 'name': 'Mato Grosso', 'abbreviation': 'MT' },
    { 'id': 12, 'name': 'Mato Grosso do Sul', 'abbreviation': 'MS' },
    { 'id': 13, 'name': 'Minas Gerais', 'abbreviation': 'MG' },
    { 'id': 14, 'name': 'Pará', 'abbreviation': 'PA' },
    { 'id': 15, 'name': 'Paraíba', 'abbreviation': 'PB' },
    { 'id': 16, 'name': 'Paraná', 'abbreviation': 'PR' },
    { 'id': 17, 'name': 'Pernambuco', 'abbreviation': 'PE' },
    { 'id': 18, 'name': 'Piauí', 'abbreviation': 'PI' },
    { 'id': 19, 'name': 'Rio de Janeiro', 'abbreviation': 'RJ' },
    { 'id': 20, 'name': 'Rio Grande do Norte', 'abbreviation': 'RN' },
    { 'id': 21, 'name': 'Rio Grande do Sul', 'abbreviation': 'RS' },
    { 'id': 22, 'name': 'Rondônia', 'abbreviation': 'RO' },
    { 'id': 23, 'name': 'Roraima', 'abbreviation': 'RR' },
    { 'id': 24, 'name': 'Santa Catarina', 'abbreviation': 'SC' },
    { 'id': 25, 'name': 'São Paulo', 'abbreviation': 'SP' },
    { 'id': 26, 'name': 'Sergipe', 'abbreviation': 'SE' },
    { 'id': 27, 'name': 'Tocantins', 'abbreviation': 'TO' }
]

options.cities = []
options.neighborhoods = []
options.zones = []

Vue.component('addressing', {
    twoWay: true,
    template: template,
    props: {
        form: String,
        model: {
            twoWay: true,
            default: {}
        },
        withZone: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        withBlock: {
            default: true
        },
        withComplementary: {
            default: true
        },
        withNumber: {
            default: true
        },
        withCondominium:{
            default: true
        }
    },
    data () {
        return {
            ui: {
                state: null,
                city: null,
                neighborhood: null
            },
            search: {
                state: null,
                city: null,
                neighborhood: null
            },
            options: options
        }
    },
    ready () {
        this.neighborhoodsLookup()
    },
    methods: {
        zipcodeSelected (address) {
            this.zipCodeSearch(address.zipcode, {
                state_id: address.state_id,
                city_id: address.city_id,
                neighborhood_id: address.neighborhood_id
            })
        },
        zipCodeSearch (zipcode, modelAfterSearch = {}) {
            if (!zipcode) {
                return
            }

            zipcode = zipcode.replace(/([0-9]{5})-?([0-9]{3})/, '$1-$2')

            this.model.zipcode = zipcode

            client
                .silent()
                .block(this.$el)
                .get('Carregando...', `/utils/zipcodes/${zipcode}`)
                .then(vueChaos(this.$el))
                .then((data) => {
                    this.options.neighborhoods = data.neighborhoods

                    this.model.state = data.state
                    this.model.city = data.city
                    this.model.state_id = data.state.id
                    this.model.city_id = data.city.id

                    const neighborhood_id = modelAfterSearch.neighborhood_id || data.neighborhood_id || null

                    this.model.neighborhood = data.neighborhoods.filter(_ => _.id === neighborhood_id).shift()

                    this.model.neighborhood_id = neighborhood_id

                    if (data.street) {
                        this.model.street = data.street.name
                    }
                })
                .catch(() => {
                    this.model.zipcode = null
                })
        },
        zipcodeKeydown (evt) {
            if (evt.which === 13) {
                this.zipCodeLookup()
                evt.preventDefault()
                return false
            }
        },
        getCityName () {
            return this.model.city ? this.model.city.name : ''
        },
        getStateName () {
            return this.model.state ? this.model.state.name : ''
        },
        zipCodeLookup () {
            if (!this.model.zipcode) {
                return
            }

            if (!/[0-9]{5}-?[0-9]{3}/.test(this.model.zipcode)) {
                return
            }

            if (cache.hasOwnProperty(this.model.zipcode)) {
                const data = cache[this.model.zipcode]

                this.options.neighborhoods = data.neighborhoods

                this.model.state = data.state
                this.model.city = data.city
                this.model.state_id = data.state.id
                this.model.city_id = data.city.id

                this.model.neighborhood = R.head(data.neighborhoods)
                this.model.neighborhood_id = data.neighborhoods.map(_ => _.id).shift()

                if (data.street) {
                    this.model.street = data.street.name
                }

                setTimeout(() => {
                    const field = $(`[data-field='${this.form}.neighborhood_id']`)
                    field.select2('focus')
                    field.select2('open')
                }, 600)
                return
            }

            client
                .silent()
                .block(this.$el)
                .get('Procurando CEP...', `/utils/zipcodes/${this.model.zipcode}`)
                .then(vueChaos(this.$el))
                .then((data) => {
                    cache[this.model.zipcode] = data

                    this.options.neighborhoods = data.neighborhoods

                    this.model.state = data.state
                    this.model.city = data.city
                    this.model.state_id = data.state.id
                    this.model.city_id = data.city.id

                    this.model.neighborhood = R.head(data.neighborhoods)
                    this.model.neighborhood_id = data.neighborhoods.map(_ => _.id).shift()

                    if (data.street) {
                        this.model.street = data.street.name
                    }

                    setTimeout(() => {
                        const field = $(`[data-field='${this.form}.neighborhood_id']`)
                        field.select2('focus')
                        field.select2('open')
                    }, 600)
                })
                .catch(() => {
                    this.model.zipcode = null
                })
        },
        neighborhoodChanged (a, b) {
            if (b) {
                this.model.neighborhood = b
            }
        },
        neighborhoodsLookup () {
            if (!this.model.zipcode) {
                return
            }

            if (!/[0-9]{5}-?[0-9]{3}/.test(this.model.zipcode)) {
                return
            }

            if (cache.hasOwnProperty(this.model.zipcode)) {
                const data = cache[this.model.zipcode]
                this.options.neighborhoods = data.neighborhoods
                return
            }

            const $block = $(this.$el)

            client
                .background()
                .block($block)
                .get('Procurando CEP...', `/utils/zipcodes/${this.model.zipcode}`)
                .then(vueChaos($block))
                .then((data) => {
                    cache[this.model.zipcode] = data

                    this.options.neighborhoods = data.neighborhoods
                })
                .catch(() => {
                    this.model.zipcode = null
                })
        },
        cityChanged (id, value) {
            this.ui.neighborhood = null
            this.options.neighborhoods = []
            this.search.city = value.name

            if (id && value) {
                client
                    .silent()
                    .block(this.$els.form)
                    .post('Buscando...', `utils/neighborhoods/search`, this.search)
                    .then((data) => {
                        this.options.neighborhoods = data.data
                    })
            }
        },
        stateChanged (id, value) {
            this.ui.city = null
            this.options.cities = []
            this.search.state = value.abbreviation

            if (id && value) {
                client
                    .silent()
                    .block(this.$els.form)
                    .post('Buscando...', `utils/cities/search`, this.search)
                    .then((data) => {
                        this.options.cities = data.data
                    })
            }
        }
    },
    watch: {
        'model': function (newVal, oldVal) {
            this.neighborhoodsLookup()
        }
        // 'model.zipcode': function (newVal, oldVal) {
        //     this.zipCodeLookup()
        // }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/addressing.js